import { render, staticRenderFns } from "./MdfeCertificate.vue?vue&type=template&id=d3a9b452&scoped=true"
import script from "./MdfeCertificate.vue?vue&type=script&lang=js"
export * from "./MdfeCertificate.vue?vue&type=script&lang=js"
import style0 from "./MdfeCertificate.vue?vue&type=style&index=0&id=d3a9b452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a9b452",
  null
  
)

export default component.exports